import { BaseApiService } from '@shared/services/BaseApiService';
import { SMS_MODULE_URL } from '@shared/helpers/env';
class StatServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  getGeneral(params) {
    return this.http
      .get('general-statistics/general', { params })
      .then((response) => ({ data: response }));
  }

  getDetailed(params) {
    return this.http.get('messages/detailed', { params });
  }
}

export const StatService = new StatServiceClass({
  api_version: 1,
  resource: 'stats',
  base_url: SMS_MODULE_URL
});

class ArchivedStatServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  getGeneral(params) {
    return this.http.get('general', { params });
  }

  getDetailed(params) {
    return this.http.get('detailed', { params });
  }
}

export const ArchivedStatService = new ArchivedStatServiceClass({
  api_version: 2,
  resource: 'stats/mailing'
});
